// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_13eb28e9","list":"_b440a798","link":"_bfc4c3a"};